module.exports = __webpack_public_path__ + "static/media/E12.3664343d.jpg";